import api, { useApi } from '@utils/api'
import { API_ENDPOINTS } from '@utils/api-endpoints'

export const useGetShopDiscounts = (shopId: string, query?: string) => {
  const url: string = `${API_ENDPOINTS.GET_SHOP_DISCOUNTS(shopId)}`
  const { data, isError, isLoading } = useApi(shopId && url)
  return {
    results: data?.data?.data,
    isLoading,
    isError,
  }
}
